/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cmspost_Publish1Inputs */

const vi_cmspost_publish1 = /** @type {(inputs: Cmspost_Publish1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đăng`)
};

/**

* @param {Cmspost_Publish1Inputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
const cmspost_publish1 = /** @type {((inputs?: Cmspost_Publish1Inputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cmspost_Publish1Inputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_cmspost_publish1(inputs)
});
export { cmspost_publish1 as "cmsPost_publish" }